export enum EditCheckPointTab {
  INFOS = 'infos',
  CONFIGS = 'configs',
}
